var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChocolateBarIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Chocolate_Bar_icon_svg__clip0_1_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.833 262.186l-118.77-68.571-68.571 118.769 118.769 68.571 68.572-118.769zM663.61 330.755l-118.769-68.571-68.571 118.769 118.769 68.571 68.571-118.769zM782.378 399.33l-118.769-68.571-68.572 118.769 118.769 68.571 68.572-118.769z",
    fill: "#806B4B",
    stroke: "#BE7F4D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.821 276.119l-57.309-33.095-12.452-49.405 118.773 68.571-49.012 13.929zM614.595 344.69l-57.309-33.095-12.453-49.405 118.774 68.572-49.012 13.928z",
    fill: "#806B4B",
    stroke: "#BE7F4D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.369 413.262l-57.321-33.083-12.441-49.417 118.774 68.571-49.012 13.929z",
    fill: "#806B4B",
    stroke: "#BE7F4D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.669 323.819l22.381-38.765c3.288-5.694 1.337-12.975-4.357-16.263l-38.765-22.381c-5.694-3.287-12.975-1.336-16.262 4.358l-22.381 38.765c-3.288 5.694-1.337 12.975 4.357 16.262l38.765 22.381c5.694 3.287 12.975 1.337 16.262-4.357zM588.434 392.394l22.381-38.765c3.287-5.694 1.336-12.975-4.358-16.262l-38.765-22.381c-5.694-3.288-12.975-1.337-16.262 4.357l-22.381 38.765c-3.287 5.694-1.336 12.975 4.357 16.262l38.765 22.381c5.694 3.288 12.975 1.337 16.263-4.357zM707.216 460.959l22.381-38.765c3.287-5.694 1.336-12.975-4.358-16.262l-38.765-22.381c-5.694-3.287-12.975-1.337-16.262 4.357l-22.381 38.765c-3.287 5.694-1.336 12.975 4.357 16.263l38.765 22.38c5.694 3.288 12.975 1.337 16.263-4.357z",
    fill: "#BE7F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.405 143.417L544.833 262.19 426.06 193.619l9.142-15.833c6.893 3.976 14.286 6.297 21.727 7.059a54.594 54.594 0 0019.809-1.559 52.007 52.007 0 003.012-.905c12.381-4.06 23.357-12.512 30.393-24.679a54.726 54.726 0 007.19-23.131A54.661 54.661 0 00535.119 151c9.488 5.476 19.929 7.798 30.107 7.286a54.978 54.978 0 0027.572-9.024 53.833 53.833 0 0012.023-10.81l8.584 4.953v.012zM732.179 211.989L613.41 143.418l-68.571 118.769 118.769 68.571 68.571-118.769zM850.957 280.558l-118.769-68.571-68.571 118.769 118.769 68.571 68.571-118.769z",
    fill: "#806B4B",
    stroke: "#BE7F4D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.167 225.917l-57.31-33.084-12.452-49.416 118.774 68.571-49.012 13.929zM801.94 294.488l-57.309-33.083-12.452-49.417 118.773 68.571-49.012 13.929z",
    fill: "#806B4B",
    stroke: "#BE7F4D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.226 158.298l-26.988 46.75c-3.286 5.69-10.571 7.642-16.262 4.357l-45.238-26.119a52.007 52.007 0 003.012-.905c12.381-4.06 23.357-12.512 30.393-24.679a54.726 54.726 0 007.19-23.131A54.661 54.661 0 00535.119 151c9.488 5.476 19.929 7.798 30.107 7.286v.012zM657.009 273.618l22.381-38.765c3.287-5.694 1.337-12.975-4.357-16.262l-38.765-22.381c-5.694-3.288-12.975-1.337-16.263 4.357l-22.381 38.765c-3.287 5.694-1.336 12.975 4.358 16.262l38.765 22.381c5.694 3.288 12.975 1.337 16.262-4.357zM775.785 342.193l22.381-38.765c3.288-5.694 1.337-12.974-4.357-16.262l-38.765-22.381c-5.694-3.287-12.975-1.336-16.262 4.358l-22.381 38.765c-3.288 5.694-1.337 12.974 4.357 16.262l38.765 22.381c5.694 3.287 12.975 1.336 16.262-4.358z",
    fill: "#BE7F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.53 485.361L368.468 265.933 149.04 645.994l380.061 219.429L748.53 485.361z",
    fill: "#CAE0E3",
    stroke: "#95C2C7",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.532 485.359L368.471 265.93 185.614 582.648l380.061 219.429 182.857-316.718z",
    fill: "#2A848E",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.631 557.202c-24.786 2.393-41.917-24.226-29.464-45.797l21.19-36.703L385.548 438c12.452-21.571 44.071-20.048 54.392 2.619l16.012 35.155c15.691 34.44-7.202 74.083-44.869 77.726l-38.44 3.714-.012-.012zM494.214 627.393c10.322 22.666 41.941 24.19 54.393 2.619l21.191-36.703 21.19-36.702c12.452-21.571-4.679-48.19-29.464-45.798l-38.441 3.715c-37.666 3.631-60.559 43.285-44.869 77.726l16.012 35.155-.012-.012z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.803 516.17l-21.65-12.5c-7.323-4.228-16.686-1.719-20.914 5.603l-12.5 21.651c-4.227 7.323-1.718 16.686 5.604 20.913l21.651 12.5c7.322 4.228 16.685 1.719 20.913-5.603l12.5-21.651c4.228-7.322 1.719-16.686-5.604-20.913z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.583 545.762L368.476 265.94 558.5 375.655l190.036 109.714-187.953 60.393z",
    fill: "#A0D1D6",
    stroke: "#3DA2AD",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.143 458.905l338.393 26.464L558.5 375.655 368.476 265.94l41.667 192.965z",
    fill: "#CAE0E3",
    stroke: "#95C2C7",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Chocolate_Bar_icon_svg__clip0_1_41"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChocolateBarIcon);
export default ForwardRef;